import { render, staticRenderFns } from "./quickEditClue.vue?vue&type=template&id=f536b106&scoped=true"
import script from "./quickEditClue.vue?vue&type=script&lang=js"
export * from "./quickEditClue.vue?vue&type=script&lang=js"
import style0 from "./quickEditClue.vue?vue&type=style&index=0&id=f536b106&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f536b106",
  null
  
)

export default component.exports